// frontend/src/routes/index.jsx - LPS Solutions route manifest.
// Persona-first layout (docs/webapp-ia.md): '/' lands each role on its home -
// clinicians/managers on My Day, admins on Subjects, auditors on Audit.
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Profile from '../pages/Profile';
import AdminPanel from '../pages/AdminPanel';
import HelpCenter from '../pages/LpsHelpPage';
import RecordingsPage from '../pages/RecordingsPage';
import ReportPage from '../pages/ReportPage';
import LpsChatPage from '../pages/LpsChatPage';
import LpsOrgPage from '../pages/LpsOrgPage';
import LpsSecurityPage from '../pages/LpsSecurityPage';
import MyDayPage from '../pages/MyDayPage';
import SubjectsPage from '../pages/SubjectsPage';
import SubjectDetailPage from '../pages/SubjectDetailPage';
import MyPracticePage from '../pages/MyPracticePage';
import SettingsPage from '../pages/SettingsPage';
import AdminGuard from '../components/guards/AdminGuard';

const ALL = ['super_admin', 'admin', 'manager', 'user', 'readonly'];

function RoleHome() {
  const { user } = useAuth();
  const role = user?.role;
  if (role === 'user' || role === 'manager') return <MyDayPage />;
  if (role === 'readonly') return <Navigate to="/security" replace />;
  return <Navigate to="/subjects" replace />;
}

const routes = [
  { path: '/', element: <RoleHome />, roles: ALL },
  { path: 'home', element: <RoleHome />, roles: ALL },
  { path: 'dashboard', element: <Navigate to="/" replace />, roles: ALL },
  { path: 'subjects', element: <SubjectsPage />, roles: ['super_admin', 'admin', 'manager', 'user'] },
  { path: 'subjects/:subjectId', element: <SubjectDetailPage />, roles: ['super_admin', 'admin', 'manager', 'user'] },
  { path: 'practice', element: <MyPracticePage />, roles: ['super_admin', 'admin', 'manager', 'user'] },
  { path: 'recordings', element: <RecordingsPage />, roles: ALL },
  { path: 'recordings/:recordingId', element: <ReportPage />, roles: ALL },
  { path: 'chat', element: <LpsChatPage />, roles: ['super_admin', 'admin', 'manager', 'user'] },
  { path: 'security', element: <LpsSecurityPage />, roles: ['super_admin', 'admin', 'readonly'] },
  { path: 'organization-lps', element: <AdminGuard><LpsOrgPage /></AdminGuard>, roles: ['super_admin', 'admin'] },
  { path: 'admin', element: <AdminGuard><AdminPanel /></AdminGuard>, roles: ['super_admin', 'admin'] },
  { path: 'customer-admin', element: <AdminGuard><AdminPanel /></AdminGuard>, roles: ['admin'] },
  { path: 'settings', element: <SettingsPage />, roles: ALL },
  { path: 'profile', element: <Profile />, roles: ALL },
  { path: 'help', element: <HelpCenter />, roles: ALL },
];

export default routes;
